var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dk-bryntum-grid"},[_c(_setup.BryntumGrid,_vm._b({ref:"grid",attrs:{"data":_setup.props.data}},'bryntum-grid',_setup.props.config,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }